import React from "react";
import { Box, Typography } from "@mui/material";

export default function GuideProgressBar({ completedCount, total, palette }) {
  const pct = total > 0 ? Math.round((completedCount / total) * 100) : 0;
  return (
    <Box sx={{ mb: 1.5 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 0.75,
        }}
      >
        <Typography sx={{ fontSize: "11px", color: palette.textSecondary }}>
          {completedCount} of {total} complete
        </Typography>
        <Typography
          sx={{ fontSize: "11px", fontWeight: 600, color: palette.textPrimary }}
        >
          {pct}%
        </Typography>
      </Box>
      <Box
        sx={{
          height: 4,
          borderRadius: 99,
          backgroundColor: palette.chipBg,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            height: "100%",
            width: `${pct}%`,
            borderRadius: 99,
            backgroundColor: palette.accent,
            transition: "width 0.25s ease",
          }}
        />
      </Box>
    </Box>
  );
}
